import React, { useState, useEffect, useRef } from 'react';
import { WifiOff, Loader2 } from 'lucide-react';
import { getConnectionDown } from '../../lib/connectionMonitor';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Fixed top banner shown while the API is unreachable. Probes /api/health
// every 10s (rate-limiter exempt) so the banner clears itself even if the
// user is idle and no app polling is running.
const ConnectionBanner = () => {
  const [down, setDown] = useState(getConnectionDown());
  const probeRef = useRef(null);

  useEffect(() => {
    const onChange = (e) => setDown(e.detail.down);
    window.addEventListener('api-connection', onChange);
    return () => window.removeEventListener('api-connection', onChange);
  }, []);

  useEffect(() => {
    if (!down) {
      clearInterval(probeRef.current);
      return;
    }
    probeRef.current = setInterval(() => {
      // Success/failure is recorded by the fetch wrapper in connectionMonitor.
      fetch(`${BACKEND_URL}/api/health`).catch(() => {});
    }, 10000);
    return () => clearInterval(probeRef.current);
  }, [down]);

  if (!down) return null;

  return (
    <div
      data-testid="connection-banner"
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950 shadow-md"
    >
      <WifiOff className="h-4 w-4" data-testid="connection-banner-icon" />
      <span data-testid="connection-banner-text">Connection issue — reconnecting…</span>
      <Loader2 className="h-4 w-4 animate-spin" />
    </div>
  );
};

export default ConnectionBanner;
